import { API } from "../config/axiosConfig";
import endpoints from "../endpoints/endpoints";

const adminModule = {
  // Step 1: Admin login with email and password
  adminLogin: async (email, password) => {
    try {
      const response = await API.post("/api/users/admin-login/", {
        email,
        password,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Admin login failed",
      };
    }
  },

  // Step 2: Verify OTP/Access code
  verifyAdminOTP: async (email, otp) => {
    try {
      const response = await API.post("/api/users/admin-login/verify/", {
        email,
        otp,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "OTP verification failed",
      };
    }
  },

  // Get admin dashboard statistics
  getAdminDashboardStats: async () => {
    try {
      const response = await API.get("/api/dashboard/admin-dashboard-stats");
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Failed to fetch dashboard stats",
      };
    }
  },
  getUsersList: async (params = {}) => {
    try {
      const { index = 0, offset = 10, ...otherParams } = params;
      const queryParams = new URLSearchParams({
        index: String(index),
        offset: String(offset),
        ...otherParams,
      });

      const response = await API.get(`${endpoints.getUsersList}?${queryParams.toString()}`);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || "Users fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || error.message || "Failed to fetch users",
        error: error.response?.data || error,
      };
    }
  },

  // Activate a user account
  activateUser: async (user_id) => {
    try {
      const response = await API.post(endpoints.activateUser, { user_id });
      return {
        success: true,
        data: response.data,
        message: response.data?.message || "User activated successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || error.message || "Failed to activate user",
        error: error.response?.data || error,
      };
    }
  },

  // Deactivate a user account
  deactivateUser: async (user_id) => {
    try {
      const response = await API.post(endpoints.deactivateUser, { user_id });
      return {
        success: true,
        data: response.data,
        message: response.data?.message || "User deactivated successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || error.message || "Failed to deactivate user",
        error: error.response?.data || error,
      };
    }
  },

  // Get system settings
  getSystemSettings: async () => {
    try {
      const response = await API.get("/api/dashboard/system-setting");
      return {
        success: true,
        data: response.data,
        message: response.data?.message || "System settings fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || error.message || "Failed to fetch system settings",
        error: error.response?.data || error,
      };
    }
  },

  // Update system settings
  updateSystemSettings: async (settings) => {
    try {
      const response = await API.put("/api/dashboard/system-setting", settings);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || "System settings updated successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || error.message || "Failed to update system settings",
        error: error.response?.data || error,
      };
    }
  },
};

export default adminModule;
